import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { modal, useComponentModalInstance } from '@/share/components';
import { useTableFormatter } from '@/share/hooks/common';

import { ref, computed, toRaw, unref, reactive, onMounted, toValue, watch } from 'vue';
export default {
  __name: 'mg-org-user-picker-view',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const listPageRef = ref();
    const $componentModal = useComponentModalInstance();
    const props = __props;
    const {
      useBoolFormatter
    } = useTableFormatter();
    const getCurrentRow = () => {
      if (listPageRef.value) {
        return listPageRef.value.getCurrentRow();
      }
      return null;
    };
    const selectRows = computed(() => {
      if (!listPageRef.value) {
        return [];
      }
      return props.multiple ? toRaw(unref(listPageRef.value.getCheckboxRows())) : [toRaw(unref(listPageRef.value.getRadioRow()))];
    });
    const listPageOptions = reactive({
      toolbar: null,
      gridProps: {
        radioConfig: {
          trigger: 'row'
        },
        checkboxConfig: {
          trigger: 'row'
        }
      },
      searchFields: [{
        field: 'search',
        title: '搜索名称或联系电话',
        span: 24,
        itemRender: {
          name: 'VxeInput'
        }
      }],
      columns: [{
        type: props.multiple ? 'checkbox' : 'radio',
        title: '选择',
        width: 50,
        fixed: 'left'
      }, {
        field: 'username',
        title: '登录账号',
        width: 120
      }, {
        field: 'nickname',
        title: '昵称',
        width: 130
      }, {
        field: 'gender',
        title: '性别',
        width: 80
      }, {
        field: 'mobile',
        title: '联系电话',
        width: 120
      }, {
        field: 'email',
        title: '邮箱',
        width: 180
      }, {
        field: 'creator',
        title: '机构创建人',
        width: 90,
        formatter: useBoolFormatter('creator')
      }, {
        field: 'admin',
        title: '机构管理人',
        width: 90,
        formatter: useBoolFormatter('admin')
      }],
      queryConfig: {
        api: 'org.getMyOrgUserPage'
      }
    });
    const refresh = () => {
      !!listPageRef.value && listPageRef.value.refresh();
    };
    const loadData = (params = {}) => {
      !!listPageRef.value && listPageRef.value.loadData({
        ...params
      });
    };
    const reloadData = (params = {}) => {
      !!listPageRef.value && listPageRef.value.reloadData({
        ...params
      });
    };
    const handleToolbarItemClick = ({
      item
    }) => {
      const {
        name
      } = item || {};
      switch (name) {
        case 'select-done':
          break;
      }
    };
    const handleRowDblClick = ({
      row
    }) => {
      if (!props.multiple) {
        const {
          id,
          ...more
        } = row;
        if (id && $componentModal.isModal()) {
          $componentModal.confirm([{
            id,
            ...more
          }]);
        }
      }
    };
    onMounted(() => {
      loadData();
    });
    const getSelectRows = () => {
      const rawRows = (unref(selectRows.value) || []).reduce((prev, item) => {
        prev.push(toRaw(unref(toValue(item))));
        return prev;
      }, []);
      return [...rawRows];
    };
    watch(() => props.search, val => {
      if (val) {
        loadData({
          search: val
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      refresh,
      loadData,
      reloadData,
      getCurrentRow,
      selectRows,
      confirmListener() {
        const rows = getSelectRows();
        if (rows.length === 0) {
          modal.notification.info('请先选择用户');
          return Promise.resolve(false);
        }
        return Promise.resolve(rows);
      }
    });
    return (_ctx, _cache) => {
      const _component_mg_list_page = _resolveComponent("mg-list-page");
      return _openBlock(), _createBlock(_component_mg_list_page, _mergeProps({
        ref_key: "listPageRef",
        ref: listPageRef,
        id: "my-org-user-list"
      }, _unref(listPageOptions), {
        onToolbarItemClick: handleToolbarItemClick,
        onRowDblClick: handleRowDblClick
      }), null, 16);
    };
  }
};